import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core';
import { searchCentralClients } from '../../modules/clients/actions';
import ClientSearchModal from './LegacyClientSearchModal';
import styles from './ClientSearchModal.styles';
import { getUngroupedClients, getRecentClients } from '../../modules/clients/selectors';

const mapStateToProps = ({ clientsModule }, { history, cachedClientList }) => {
  let showRecentSearches = false;

  if (history?.location?.search) {
    const searchTerm = new URLSearchParams(history.location.search).get('q');
    showRecentSearches = !searchTerm;
  }

  let clients;

  if (!showRecentSearches && cachedClientList) {
    clients = cachedClientList;
  } else {
    clients = showRecentSearches ? getRecentClients(clientsModule) : getUngroupedClients(clientsModule);
  }

  return {
    clients,
    loading: clientsModule.clientsList.loading || clientsModule.clientsRecentList.loading,
    hasMore: clientsModule.clientsList.hasMore,
  };
};

const mapDispatchToProps = {
  searchCentralClients,
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(ClientSearchModal);
